import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export const WhoIsThisFor = () => {
  const isFor = ['Madres con bebés de 0 a 12 meses que despiertan más de 3 veces por noche.', 'Mujeres que sufren de agotamiento extremo y necesitan recuperar su salud mental.', 'Padres en USA que no tienen ayuda familiar ("tribu") y deben ser productivos de día.', 'Familias con bebés "High Need" o de alta sensibilidad sensorial.'];
  const notFor = ['Personas que buscan una "pastilla mágica" sin cambiar la rutina del bebé.', 'Quienes no están dispuestos a seguir un plan consistente durante al menos 3 días.', 'Bebés con condiciones médicas graves no supervisadas por un pediatra.'];
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-240">
          {/* ES para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-brand-teal" data-id="element-241">
            <h3 className="text-2xl font-bold text-brand-navy mb-6" data-id="element-242">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-243">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-244">
                  <CheckCircle2 className="w-6 h-6 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-245" />
                  <span className="text-brand-charcoal/90" data-id="element-246">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-brand-coral" data-id="element-247">
            <h3 className="text-2xl font-bold text-brand-navy mb-6" data-id="element-248">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-249">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-250">
                  <XCircle className="w-6 h-6 text-brand-coral flex-shrink-0 mt-0.5" data-id="element-251" />
                  <span className="text-brand-charcoal/90" data-id="element-252">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};